import { useFlag } from '@unleash/proxy-client-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import { useDesignerDataContext } from '../../../hooks/useDesignerLogic';
import { useDesignerUIContext } from '../../../hooks/useDesignerUIState';
import { useMetrics } from '../../../hooks/useMetrics';
import useTabsSelector from '../../../hooks/useTabsSelector';
import { TabSelectorButton } from './DesignerTabUtils';

const DesignerTabs = () => {
  const metrics = useMetrics();
  const { t } = useTranslation('Host');
  const { editorSelector, newSlideSelector, aiEditorSelector } = useTabsSelector();

  const useAITemplates = useFlag('AI_TEMPLATES');

  const selectedTab = useDesignerUIContext(context => context.state.selectedTab);
  const isLeftTabCollapsed = useDesignerUIContext(
    context => context.state.isLeftTabCollapsed,
  );

  const handleSelectedTabChange = useDesignerDataContext(c => c.handleSelectedTabChange);
  return (
    <FloatingContainer>
      {useAITemplates && (
        <>
          {aiEditorSelector.map((button, i) => {
            return (
              <TabSelectorButton
                key={i}
                type="ghost"
                icon={button.icon}
                $active={!isLeftTabCollapsed && selectedTab.tab === button.tabTitle}
                onClick={() => {
                  metrics.logEvent('Creator.ChangeTab', { selectedTab });
                  handleSelectedTabChange({ tab: button.tabTitle, subTab: undefined });
                }}
              >
                {t(button.displayTitle)}
              </TabSelectorButton>
            );
          })}
          <TabHorizontalDivider />
        </>
      )}
      {newSlideSelector.map((button, i) => {
        return (
          <TabSelectorButton
            key={i}
            type="ghost"
            icon={button.icon}
            $active={!isLeftTabCollapsed && selectedTab.tab === button.tabTitle}
            onClick={() => {
              metrics.logEvent('Creator.ChangeTab', { selectedTab });
              handleSelectedTabChange({ tab: button.tabTitle, subTab: undefined });
            }}
          >
            {t(button.displayTitle)}
          </TabSelectorButton>
        );
      })}
      <TabHorizontalDivider />
      {editorSelector.map((button, i) => {
        return (
          <TabSelectorButton
            key={i}
            type="ghost"
            icon={button.icon}
            $active={!isLeftTabCollapsed && selectedTab.tab === button.tabTitle}
            onClick={() => {
              metrics.logEvent('Creator.ChangeTab', { selectedTab });
              handleSelectedTabChange({ tab: button.tabTitle, subTab: undefined });
            }}
          >
            {t(button.displayTitle)}
          </TabSelectorButton>
        );
      })}
    </FloatingContainer>
  );
};

export default DesignerTabs;

const TabHorizontalDivider = styled.div`
  margin: 10px 5%;
  width: 90%;
  background-color: ${theme.colors.grey};
  height: 1px;
`;

const FloatingContainer = styled.div`
  width: 100%;
  height: calc(100% - 10px);

  display: block;
  margin: 5px;
  overflow-y: auto;
  overflow-x: hidden;

  background-color: white;
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
  border-radius: ${theme.effects.floatingCreatorElementBorderRadius};

  @media (max-width: 800px) {
    height: 70px;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    width: calc(100% - 12px);
    margin: 0px 6px 6px 6px;
  }
`;
